"use client";
import React, { useState } from "react";
import RtgLogo from "/public/assets/rtg-logo.svg";
import YearLogo from "/public/assets/18-year-logo.svg";
import CDSLogo from "/public/assets/cds.svg";
import Image from "next/image";
import Link from "next/link";

export default function BarFooter({ isElite = false }) {
  const [showMore, setShowMore] = useState(false);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const firstParagraph = `Welcome to GOAT Spins Casino, where best players meet gaming excellence. In the prestigious world of GOAT Spins, our dedicated team is committed to upholding fairness and delivering an exceptional gaming experience. Our promise? Ensuring every player enjoys instant withdrawals, as quick as a champion sprinter. No hidden tricks, just unbeatable odds waiting for those daring enough to take the plunge!`;

  const additionalContent = (
    <>
      <p>
        Most players prefer Bitcoin, the leading crypto method, but at GOAT
        Spins, we offer a variety of other crypto options. Players are welcome
        to deposit in BTC, LTC, ETH, Tether, Binance. For more details, visit
        our{" "}
        <Link className="TextLinksGreen" href="/banking">
          Banking page
        </Link>
        .
      </p>

      <h2>About GOAT Spins</h2>
      <p>
        Established in 2024, GOAT Spins ambitiously aims to become a standout
        name in the online casino industry. Offering a vast array of games
        developed by Spin Logic Slots, GOAT Spins emphasizes instant withdrawals
        and an unparalleled gaming experience.
      </p>

      <h3>Games Galore</h3>

      <p>
        Explore a rich selection of hundreds of games created by Spin Logic
        Slots (formerly Real Time Gaming). From beloved classics to sought-after
        titles like slots, Blackjack, Video Poker, online roulette, and
        Baccarat, there&apos;s something for every gaming enthusiast.
      </p>

      <p>
        Our prized slots include gems like the Cash Bandits series, Bubble
        Bubble series, Plentiful Treasure, followed with Mighty Drums as a
        sequel and Wild Hog Luau.
      </p>

      <h3>Mobile Excellence</h3>

      <p>
        Life moves fast, and so does gaming at GOAT Spins. Enjoy seamless access
        to our games on iOS and Android devices with our responsive mobile
        platform, complementing our user-friendly desktop site.
      </p>

      <h3>Bonuses and Promotions</h3>

      <p>
        Prepare to be amazed by GOAT Spins&apos; generous bonuses and frequent
        promotions, ensuring every player feels like a VIP. Our welcome bonus
        offers a glimpse into the extraordinary benefits available. Don&apos;t miss
        out—{" "}
        <Link className="TextLinksGreen" href="https://goatspins.com/">
          redeem it now!
        </Link>
        .
      </p>

      <h3>Regular Promotions</h3>

      <p>
        We&apos;re dedicated to keeping you engaged and rewarded. Whether you&apos;re a
        high roller or prefer low-risk play, our diverse promotional offers
        cater to every taste. Can&apos;t find the perfect deal? Contact our{" "}
        <Link className="TextLinksGreen" href="https://goatspins.com/support">
          live chat support
        </Link>
        — they&apos;re here to help. .
      </p>

      <h3>Why Choose GOAT Spins?</h3>

      <p>
        Selecting a trustworthy gaming platform is essential. At GOAT Spins, we
        stand out with:
      </p>

      <h4 style={{ marginLeft: "2rem" }}>Proven Slot Classics</h4>

      <p style={{ marginLeft: "2rem" }}>
        Timeless Classics: Enjoy proven slot classics that deliver both
        excitement and rewards.
      </p>

      <h4 style={{ marginLeft: "2rem" }}>Safety</h4>

      <p style={{ marginLeft: "2rem" }}>
        Safety First: Your safety comes first. The GOAT Spins ensures your data
        is protected to the highest standards. For more details, please see the{" "}
        <Link className="TextLinksGreen" href="https://goatspins.com/policy">
          Privacy Policy page
        </Link>
        .
      </p>

      <h4 style={{ marginLeft: "2rem" }}>Responsible Gaming</h4>

      <p style={{ marginLeft: "2rem" }}>
      Responsible Gaming: We promote responsible gaming practices, providing resources to support healthy play habits. Visit our {" "}
        <Link
          className="TextLinksGreen"
          href="https://goatspins.com/responsible-gambling"
        >
          Responsible Gambling page
        </Link>
        for more information
        .
      </p>
    </>
  );

  return (
    <>
      <div className="ContFooter">
        <h1>
          The GOAT Spins Casino – Your Favorite{" "}
          <span className="ColorGreen">Crypto Casino</span>
        </h1>
        <div>
          {firstParagraph}
          {showMore && <span>{additionalContent}</span>}
        </div>
        {!showMore && (
          <span onClick={toggleShowMore} className="TextLinksGreen">
            READ MORE
          </span>
        )}
      </div>

      <div id="BarFooter">
        <Image
          width={60}
          height={60}
          src={YearLogo.src}
          alt="YEAR LOGO"
          className="YearLogo"
        />
        <Image
          width={200}
          height={60}
          src={CDSLogo.src}
          alt="CDS LOGO"
          className="CDSLogo"
        />
        <Image
          width={200}
          height={60}
          src={RtgLogo.src}
          alt="RTG LOGO"
          className="RtgLogo"
        />
        {isElite && (
          <>
            <div className="RowsFooter">
              <h2>Socials:</h2>
            </div>
            <div className="RowsFooter">
              <Link
                href="https://trs.ink/ActivationContext?context=mro"
                target="_blank"
                rel="noopener noreferrer"
                className="IconSocial Vib"
              ></Link>
              <Link
                href="https://t.me/My_Mr_O_bot"
                target="_blank"
                rel="noopener noreferrer"
                className="IconSocial Tel"
              ></Link>
            </div>
          </>
        )}
        <div className="RowsFooter">
          Copyright © <span>{new Date().getFullYear()}</span>. All rights reserved.
        </div>

        <div className="animation-wrapper">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <div className="particle particle-4"></div>
        </div>
      </div>
    </>
  );
}
